















































import Vue, { DirectiveOptions } from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

function getTarget(node: any) {
	if (node === void 0) {
		node = document.body;
	}
	if (node === true) {
		return document.body;
	}
	return node instanceof (window as any).Node
		? node
		: document.querySelector(node);
}

const TransferDom: DirectiveOptions = {
	inserted(el, { value }, vnode) {
		if (el.dataset && el.dataset.transfer !== "true") return false;
		el.className = el.className
			? el.className + " v-transfer-dom"
			: "v-transfer-dom";
		const parentNode = el.parentNode;
		if (!parentNode) return;
		const home = document.createComment("");
		let hasMovedOut = false;

		if (value !== false) {
			parentNode.replaceChild(home, el); // moving out, el is no longer in the document
			getTarget(value).appendChild(el); // moving into new place
			hasMovedOut = true;
		}
		if (!(el as any).__transferDomData) {
			(el as any).__transferDomData = {
				parentNode: parentNode,
				home: home,
				target: getTarget(value),
				hasMovedOut: hasMovedOut
			};
		}
	},
	componentUpdated(el, { value }) {
		if (el.dataset && el.dataset.transfer !== "true") return false;
		// need to make sure children are done updating (vs. `update`)
		const ref$1 = (el as any).__transferDomData;
		if (!ref$1) return;
		// homes.get(el)
		const parentNode = ref$1.parentNode;
		const home = ref$1.home;
		const hasMovedOut = ref$1.hasMovedOut; // recall where home is

		if (!hasMovedOut && value) {
			// remove from document and leave placeholder
			parentNode.replaceChild(home, el);
			// append to target
			getTarget(value).appendChild(el);
			(el as any).__transferDomData = Object.assign(
				{},
				(el as any).__transferDomData,
				{
					hasMovedOut: true,
					target: getTarget(value)
				}
			);
		} else if (hasMovedOut && value === false) {
			// previously moved, coming back home
			parentNode.replaceChild(el, home);
			(el as any).__transferDomData = Object.assign(
				{},
				(el as any).__transferDomData,
				{
					hasMovedOut: false,
					target: getTarget(value)
				}
			);
		} else if (value) {
			// already moved, going somewhere else
			getTarget(value).appendChild(el);
		}
	},
	unbind(el) {
		if (el.dataset && el.dataset.transfer !== "true") return false;
		el.className = el.className.replace("v-transfer-dom", "");
		const ref$1 = (el as any).__transferDomData;
		if (!ref$1) return;
		if ((el as any).__transferDomData.hasMovedOut === true) {
			(el as any).__transferDomData.parentNode &&
				(el as any).__transferDomData.parentNode.appendChild(el);
		}
		(el as any).__transferDomData = null;
	}
};

const findBrothersComponents = function(
	context: any,
	componentName: string,
	exceptMe = true
) {
	let res = context.$parent.$children.filter((item: any) => {
		return item.$options.name === componentName;
	});
	let index = res.findIndex((item: any) => item._uid === context._uid);
	if (exceptMe) res.splice(index, 1);
	return res;
};

const findComponentsUpward = function(
	context: any,
	componentName: string
): any {
	let parents = [];
	const parent = context.$parent;
	if (parent) {
		if (parent.$options.name === componentName) parents.push(parent);
		return parents.concat(findComponentsUpward(parent, componentName));
	} else {
		return [];
	}
};

const on = (function() {
	return function(element: any, event: any, handler: any) {
		if (element && event && handler) {
			element.addEventListener(event, handler, false);
		}
	};
})();

const off = (function() {
	return function(element: any, event: any, handler: any) {
		if (element && event) {
			element.removeEventListener(event, handler, false);
		}
	};
})();

const broadcast = function(
	context: any,
	componentName: string,
	eventName: string,
	params: string
) {
	context.$children.forEach((child: any) => {
		const name = child.$options.name;
		if (name === componentName) {
			child.$emit.apply(child, [eventName].concat(params));
		} else {
			// todo 如果 params 是空数组，接收到的会是 undefined
			broadcast(child, componentName, eventName, params);
		}
	});
};

@Component({
	directives: { TransferDom }
})
export default class ElDrawer extends Vue {
	@Prop({ type: Boolean, default: false }) value!: boolean;
	@Prop({ type: String }) title!: string;
	@Prop({ type: [Number, String], default: 256 }) width!: number | string;
	@Prop({ type: Boolean, default: true }) closable!: boolean;
	@Prop({ type: Boolean, default: true }) maskClosable!: boolean;
	@Prop({ type: Boolean, default: true }) mask!: boolean;
	@Prop({ type: Object }) maskStyle!: any;
	@Prop({ type: Object }) styles!: any;
	@Prop({ type: Boolean, default: false }) scrollable!: boolean;
	@Prop({
		type: String,
		default: "right",
		validator(value) {
			return !!["left", "right"].find(item => item === value);
		}
	})
	placement!: string;
	@Prop({ type: Number, default: 1000 }) zIndex!: number;
	@Prop({ type: Boolean, default: true }) transfer!: boolean;
	@Prop({ type: String }) className!: string;
	@Prop({ type: Boolean, default: false }) inner!: boolean;
	@Prop({ type: Boolean, default: false }) draggable!: boolean;
	@Prop({ type: Function }) beforeClose!: any;

	visible: boolean = !!this.value;
	wrapShow: boolean = false;
	showHead: boolean = true;
	canMove: boolean = false;
	dragWidth: number | string = this.width;
	wrapperWidth: number | string = this.width;
	wrapperLeft: number = 0;
	minWidth: number = 256;

	get wrapClasses() {
		return [
			`drawer-wrap`,
			{
				[`drawer-hidden`]: !this.wrapShow,
				[`${this.className}`]: !!this.className,
				[`drawer-no-mask`]: !this.mask,
				[`drawer-wrap-inner`]: this.inner,
				[`drawer-wrap-dragging`]: this.canMove
			}
		];
	}
	get mainStyles() {
		let style = {};
		const width = parseInt(String(this.dragWidth));
		const styleWidth = {
			width: width <= 100 ? `${width}%` : `${width}px`
		};
		Object.assign(style, styleWidth);
		return style;
	}
	get contentClasses() {
		return [
			`drawer-content`,
			{
				[`drawer-content-no-mask`]: !this.mask
			}
		];
	}
	get classes() {
		return [
			`drawer`,
			`drawer-${this.placement}`,
			{
				[`drawer-no-header`]: !this.showHead,
				[`drawer-inner`]: this.inner
			}
		];
	}
	get maskClasses() {
		return [
			`drawer-mask`,
			{
				[`drawer-mask-inner`]: this.inner
			}
		];
	}

	close() {
		if (!this.beforeClose) {
			return this.handleClose();
		}
		const before = this.beforeClose();
		if (before && before.then) {
			before.then(() => {
				this.handleClose();
			});
		} else {
			this.handleClose();
		}
	}
	handleClose() {
		this.visible = false;
		this.$emit("input", false);
		this.$emit("on-close");
	}
	handleMask() {
		if (this.maskClosable && this.mask) {
			this.close();
		}
	}
	handleWrapClick(event: MouseEvent) {
		const className = (event.target as any).getAttribute("class");
		if (className && className.indexOf(`drawer-wrap`) > -1) this.handleMask();
	}
	handleMousemove(event: MouseEvent) {
		if (!this.canMove || !this.draggable) return;
		// 更新容器宽度和距离左侧页面距离，如果是window则距左侧距离为0
		this.handleSetWrapperWidth();
		const left = event.pageX - this.wrapperLeft;
		// 如果抽屉方向为右边，宽度计算需用容器宽度减去left
		let width =
			this.placement === "right" ? (this as any).wrapperWidth - left : left;
		// 限定最小宽度
		width = Math.max(width, parseFloat((this as any).minWidth));
		(event as any).atMin = width === parseFloat((this as any).minWidth);
		// 如果当前width不大于100，视为百分比
		if (width <= 100) width = (width / (this as any).wrapperWidth) * 100;
		this.dragWidth = width;
		this.$emit("on-resize-width", parseInt((this as any).dragWidth));
	}
	handleSetWrapperWidth() {
		const { width, left } = this.$el.getBoundingClientRect();
		this.wrapperWidth = width;
		this.wrapperLeft = left;
	}
	handleMouseup() {
		if (!this.draggable) return;
		this.canMove = false;
	}
	handleTriggerMousedown() {
		this.canMove = true;
		// 防止鼠标选中抽屉中文字，造成拖动trigger触发浏览器原生拖动行为
		(window as any).getSelection().removeAllRanges();
	}
	mounted() {
		if (this.visible) {
			this.wrapShow = true;
		}
		let showHead = true;
		if (this.$slots.header === undefined && !this.title) {
			showHead = false;
		}
		this.showHead = showHead;
		on(document, "mousemove", this.handleMousemove);
		on(document, "mouseup", this.handleMouseup);
		this.handleSetWrapperWidth();
	}
	beforeDestroy() {
		off(document, "mousemove", this.handleMousemove);
		off(document, "mouseup", this.handleMouseup);
		this.removeScrollEffect();
	}

	@Watch("value")
	onValueWatch(val: any) {
		this.visible = !!val;
	}

	timer: number = 0;
	@Watch("visible")
	onVisibleWatch(val: any) {
		if (val === false) {
			this.timer = setTimeout(() => {
				this.wrapShow = false;
				// #4831 Check if there are any drawers left at the parent level
				const brotherDrawers = findBrothersComponents(this, "Drawer") || [];
				const parentDrawers = findComponentsUpward(this, "Drawer") || [];
				const otherDrawers = [].concat(brotherDrawers).concat(parentDrawers);
				const isScrollDrawer = otherDrawers.some(
					(item: any) => item.visible && !item.scrollable
				);
				if (!isScrollDrawer) {
					this.removeScrollEffect();
				}
			}, 300);
		} else {
			if (this.timer) clearTimeout(this.timer);
			this.wrapShow = true;
			if (!this.scrollable) {
				this.addScrollEffect();
			}
		}
		this.broadcast("Table", "on-visible-change", val);
		this.broadcast("Slider", "on-visible-change", val); // #2852
		this.$emit("on-visible-change", val);
	}

	@Watch("scrollable")
	onScrollableWatch(val: any) {
		if (!val) {
			this.addScrollEffect();
		} else {
			this.removeScrollEffect();
		}
	}

	@Watch("title")
	onTitleWatch(val: any) {
		if (this.$slots.header === undefined) {
			this.showHead = !!val;
		}
	}

	@Watch("width")
	onWitchWatch(val: any) {
		this.dragWidth = val;
	}

	bodyIsOverflowing: boolean = false;
	scrollBarWidth: number = 0;
	checkScrollBar() {
		let fullWindowWidth = window.innerWidth;
		if (!fullWindowWidth) {
			// workaround for missing window.innerWidth in IE8
			const documentElementRect = document.documentElement.getBoundingClientRect();
			fullWindowWidth =
				documentElementRect.right - Math.abs(documentElementRect.left);
		}
		this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth;
		if (this.bodyIsOverflowing) {
			this.scrollBarWidth = (function() {
				const inner = document.createElement("div");
				inner.style.width = "100%";
				inner.style.height = "200px";

				const outer = document.createElement("div");
				const outerStyle = outer.style;

				outerStyle.position = "absolute";
				outerStyle.top = "0";
				outerStyle.left = "0";
				outerStyle.pointerEvents = "none";
				outerStyle.visibility = "hidden";
				outerStyle.width = "200px";
				outerStyle.height = "150px";
				outerStyle.overflow = "hidden";

				outer.appendChild(inner);

				document.body.appendChild(outer);

				const widthContained = inner.offsetWidth;
				outer.style.overflow = "scroll";
				let widthScroll = inner.offsetWidth;

				if (widthContained === widthScroll) {
					widthScroll = outer.clientWidth;
				}

				document.body.removeChild(outer);

				return widthContained - widthScroll;
			})();
		}
	}
	checkMaskInVisible() {
		let masks = document.getElementsByClassName("modal-mask") || [];
		return Array.from(masks).every(
			(m: any) =>
				m.style.display === "none" || m.classList.contains("fade-leave-to")
		);
	}
	setScrollBar() {
		if (this.bodyIsOverflowing && this.scrollBarWidth !== undefined) {
			document.body.style.paddingRight = `${this.scrollBarWidth}px`;
		}
	}
	resetScrollBar() {
		document.body.style.paddingRight = "";
	}
	addScrollEffect() {
		this.checkScrollBar();
		this.setScrollBar();
		document.body.style.overflow = "hidden";
	}
	removeScrollEffect() {
		if (this.checkMaskInVisible()) {
			document.body.style.overflow = "";
			this.resetScrollBar();
		}
	}
	dispatch(componentName: string, eventName: string, params: any) {
		let parent = this.$parent || this.$root;
		let name = parent.$options.name;

		while (parent && (!name || name !== componentName)) {
			parent = parent.$parent;

			if (parent) {
				name = parent.$options.name;
			}
		}
		if (parent) {
			parent.$emit(eventName, params);
		}
	}
	broadcast(componentName: string, eventName: string, params: any) {
		broadcast(this, componentName, eventName, params);
	}
}
